"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBPopoverOnOpenChangeTrigger = void 0;
var HBPopoverOnOpenChangeTrigger = exports.HBPopoverOnOpenChangeTrigger = /*#__PURE__*/function (HBPopoverOnOpenChangeTrigger) {
  HBPopoverOnOpenChangeTrigger["TargetClick"] = "targetClick";
  HBPopoverOnOpenChangeTrigger["ClickOutside"] = "clickOutside";
  HBPopoverOnOpenChangeTrigger["EnterKey"] = "enterKey";
  return HBPopoverOnOpenChangeTrigger;
}({});
//# sourceMappingURL=HBPopover.types.js.map